import React, { createContext, useEffect, useState } from "react";
import useFakebotConvo from "../hooks/useFakebotConvo";
import { clientsMasterList, initialClinicDetails } from "../utils/constants";
import { getLogoUrl, getOfficeHours } from "../utils/messageService";
import { mergeDaysWithSameHours } from "../utils/utilityFunctions";
import useGlobalState from "global-state-hooks/useGlobalState";
export const UserDetailsContext = createContext();
const initialUserDetails = {
  email: "",
  full_name: "",
  message: "",
  token: "",
  lead_id: "",
  timeStamp: 0,
};
export default function UserDetailsManager({ children }) {
  const { clinicId } = useGlobalState();
  const [_, setFakeBotConvo] = useFakebotConvo(clinicId);

  const [details, setDetails] = useState();

  const getUserDetails = () => {
    const localStorageData = JSON.parse(
      localStorage.getItem("chat_widget_user")
    );
    const data = localStorageData?.[clinicId] || null;
    return data || null;
  };

  const updateUserDetails = (data, skipSetDetails) => {
    let userDetails = getUserDetails() || {};
    const localStorageData = JSON.parse(
      localStorage.getItem("chat_widget_user")
    );

    localStorage.setItem(
      "chat_widget_user",
      JSON.stringify({
        ...localStorageData,
        [clinicId]: { ...userDetails, ...data },
      })
    );
    if (!skipSetDetails) {
      setDetails({ ...details, user: { ...data } });
    }
  };

  const updateTimestamp = (newTimeStamp) => {
    if (!clinicId) return;
    try {
      updateUserDetails(
        {
          ...JSON.parse(localStorage.getItem("chat_widget_user"))[clinicId],
          timeStamp: newTimeStamp || Date.now(),
        },
        true
      );
    } catch {
      updateUserDetails({});
    }
  };

  const logoUrl = async (clinicDetails) => {
    await getLogoUrl(clinicId)
      .then((res) => {
        if (!res?.data?.success === "false")
          setDetails({
            ...details,
            clinic: {
              ...details?.clinic,
              url: res?.data?.data?.office_log_url,
            },
          });
        return;
      })
      .catch((e) => {
        console.log(e);
        return;
      });
  };

  const officeHours = async (clinicDetails, userDetails) => {
    await getOfficeHours(clinicId)
      .then((res) => {
        setDetails({
          user: userDetails,
          clinic: {
            ...clinicDetails,
            officeHours: mergeDaysWithSameHours(res?.data?.office_hours),
            url: res?.data?.data?.office_log_url,
          },
        });
        return;
      })
      .catch((e) => {
        console.log(e);
        return;
      });
  };
  useEffect(() => {
    if (!clinicId) {
      setDetails({ ...details, clinic: null });

      return;
    }
    //for checking whether the session has expired or not based on set expiry time
    const userDetails = getUserDetails();

    let clinicDetails = initialClinicDetails;
    clientsMasterList.forEach((item) => {
      if (item.id === clinicId) {
        clinicDetails = {
          name: item.name,
          id: item.id,
          initials: item.initials,
        };
      }
    });
    try {
      setDetails({
        clinic: clinicDetails,
        user: userDetails || initialUserDetails,
      });
    } catch {
      return setDetails({ clinic: clinicDetails, user: initialUserDetails });
    }

    const dateNow = Date.now();
    const sessionDuration = 86400; //change this value based on agreed duration (in seconds)

    if ((dateNow - userDetails?.timeStamp) / 1000 > sessionDuration) {
      updateTimestamp();
      setFakeBotConvo(null, true);
      updateUserDetails(initialUserDetails);
    }
    officeHours(clinicDetails, userDetails || initialUserDetails);
    logoUrl();
  }, [details?.clinic?.id, clinicId]);

  useEffect(() => {}, [details?.token]);

  setInterval(function () {
    updateTimestamp();
  }, 10000);

  return (
    <UserDetailsContext.Provider
      value={{
        details,
        updateUserDetails,
        updateTimestamp,
      }}
    >
      {children}
    </UserDetailsContext.Provider>
  );
}
